module.exports = __webpack_public_path__ + "images/62e4574bbee4be445278e05db481416f-West Hollywood.jpg";